import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type TipoIcono = 'success' | 'error' | 'warning' | 'info' | 'none';

export interface PopUpMensajeData {
  titulo: string;
  texto: string;
  tipoIcono?: TipoIcono;
  textoBoton?: string;
}

@Component({
  selector: 'app-pop-up-mensaje',
  templateUrl: './pop-up-mensaje.component.html',
  styleUrls: ['./pop-up-mensaje.component.css']
})
export class PopUpMensajeComponent {
  
  titulo: string;
  texto: string;
  tipoIcono: TipoIcono;
  textoBoton: string;
  icono: string = '';
  colorIcono: string = '';

  constructor(
    public dialogRef: MatDialogRef<PopUpMensajeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopUpMensajeData
  ) {
    this.titulo = data.titulo || 'Mensaje';
    this.texto = data.texto || '';
    this.tipoIcono = data.tipoIcono || 'none';
    this.textoBoton = data.textoBoton || 'ACEPTAR';
    
    this.configurarIcono();
  }

  private configurarIcono(): void {
    switch (this.tipoIcono) {
      case 'success':
        this.icono = 'check_circle';
        this.colorIcono = '#4CAF50';
        break;
      case 'error':
        this.icono = 'error_outline';
        this.colorIcono = '#f44336';
        break;
      case 'warning':
        this.icono = 'warning';
        this.colorIcono = '#ff9800';
        break;
      case 'info':
        this.icono = 'info';
        this.colorIcono = '#0372b9';
        break;
      default:
        this.icono = '';
        this.colorIcono = '';
        break;
    }
  }

  onAceptar(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
